// extracted by mini-css-extract-plugin
export var carrierIcon = "_yw-0";
export var carrierLogo = "_yw-1";
export var detailsSection = "_yw-2";